import React, { useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import RoutesPath from "../../Utils/RoutesPath";
import { Link, useNavigate } from "react-router-dom";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import { CirclesWithBar } from "react-loader-spinner";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
const MyMockTest = () => {
  const [data, setData] = useState([]);
  const [mockTestData, setMockTestData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(7);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (chapter) => {
    setShow(true);
    setMockTestData(chapter)

  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await StudentDashboardServices.getAllMockTest(
        offset,
        limit,
        searchQuery || ""
      );
      setData(response.data);

      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 100);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);
  const navigate = useNavigate();

  const handleButtonClick = (chapter) => {
    // navigate(RoutesPath.showresult);
    navigate(
      `${RoutesPath.showresult}/${chapter.mockTest_id}/${chapter.order_id}`
    );
  };
  const handleStartTest = () => {
    navigate(
      `${RoutesPath.mocktest}/${mockTestData.mockTest_id}/${mockTestData.package_id}`,
      {
        state: mockTestData,
      }
    );
  };
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="mainLayout-content">
        <StudentNavbar />
        <div className="main_content contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black  fw-700 Header-student-text mb-0">
              My Mock Test
            </h1>
          </div>
          {loading ? (
            <div className="text-center d-flex justify-content-center">
              <CirclesWithBar
                height="80"
                width="80"
                color="#F6821F"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <>
              {data.length === 0 ? (
                <div className="no-records-container text-center">
                  <div className="no-record-image">
                    <Image src={PngImages.no_record} className="img-fluid" />
                  </div>
                  <p className="no-records-text sub-large-text-one fw-700 mb-4">
                    No records found
                  </p>
                  <Link to={RoutesPath.dashboardstudent}>
                    <div className="d-flex justify-content-center">
                      <SubmitButtonTwo
                        title={"Go to Packages"}
                        className="Package-button mb-4"
                      />
                    </div>
                  </Link>
                </div>
              ) : (
                <div className=" d-flex flex-column">
                  {data.map((chapter, index) => (
                    <div key={index} className="MyMocktestcards">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-wrap justify-content-between w-100 align-items-center">
                          <div className="d-flex gap-1">
                            {/* <div>
                                                        <h3 className='fw-700 small-medium-text blue mb-0'>{chapter.packageName}</h3>
                                                        </div> */}
                            <div className="d-flex gap-2 align-items-center">
                              <h3 className="fw-700 small-medium-text blue mb-0">
                                {chapter.mockTestName}
                              </h3>
                              {
                                chapter.isPackageExpired ==true &&
                                <span className="fw-700 medium-text text-danger" style={{fontFamily:"cursive"}} >Expired</span>
                              }
                            </div>
                            {/* <div>
                                                <Image src={PngImages.free_icon} style={{ marginTop: -30, marginLeft: 7 }} />
                                            </div> */}
                          </div>

                          <div>
                            <h3 className="Caption flex-wrap mb-0 d-flex gap-1">
                              <span style={{ fontStyle: "italic" }}>
                                Note :
                              </span>
                              <span className="fw-700">
                              Mock tests are prepared based on complete syllabus and will be available for attempt accordingly for your maximum benefit.
                              </span>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-3 mocksecondsection">
                        <div className="d-flex gap-3 flex-wrap">
                          <div className="d-flex align-items-center">
                            <div>
                              <h3 className="Caption mb-0 captioncolor">
                                Subjects:&nbsp;
                                <span className="small-text fw-500 color-sub">
                                  {chapter.subjectData.length > 3 ? (
                                    <>
                                      {chapter.subjectData
                                        .slice(0, 3)
                                        .map((subject) => subject.subjectName)
                                        .join(", ")}{" "}
                                      <span
                                        className="fw-600"
                                        style={{
                                          fontStyle: "italic",
                                          color: "#4E4E4E",
                                        }}
                                      >
                                        and {chapter.subjectData.length - 3}{" "}
                                        more
                                      </span>
                                    </>
                                  ) : (
                                    chapter.subjectData
                                      .map((subject) => subject.subjectName)
                                      .join(", ")
                                  )}
                                </span>
                              </h3>
                            </div>
                          </div>
                          {/* <div className='d-flex  align-items-center'>
                                                        <div>
                                                            <h3 className='Caption mb-0 captioncolor'>Total Questions:<span className='small-text  color-sub  fw-500'>&nbsp;{chapter.numberOfQuestions ? chapter.numberOfQuestions : 0}</span></h3>
                                                        </div>
                                                    </div> */}
                          <div className="d-flex align-items-center">
                            <div>
                              <h3 className="Caption mb-0 captioncolor">
                                Time:
                                <span className="small-text  color-sub fw-500">
                                  {" "}
                                  {chapter.durationInMinutes}&nbsp;mins
                                </span>
                              </h3>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div>
                              <h3 className="Caption mb-0 captioncolor">
                                No of Attempts:
                                <span className="small-text color-sub  fw-500">
                                  {" "}
                                  {chapter.remainingAttempts}
                                </span>
                              </h3>
                            </div>
                          </div>
                          <div></div>
                        </div>
                        <div className="d-flex gap-2 responsivemockbuttonsection">
                          <div>
                            <SubmitButtonTwo
                              title={"View Results"}
                              className="Viewresultbtn"
                              onclick={() => handleButtonClick(chapter)}
                            />
                            
                          </div>
                          {chapter.remainingAttempts == 0 ? null : (
                            <div>
                              <SubmitButtonTwo
                                title={"Start Test"}
                                className="start-test-btn"
                                onclick={() => handleShow(chapter)}
                              />
                            </div>
                          )}
                          {/* <div><SubmitButtonTwo title={"Unlock Mock test"} className="start-test-btn fw-600 small-medium-text" /></div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          <div className="row mt-3 align-items-center parentcustomnavbtn">
            <div className="col-md-6 col-sm-6">
              <p
                className=" small-text fw-500 mb-0"
                style={{ opacity: "0.5", fontStyle: "italic" }}
              >
                {availableDataCount > 0
                  ? `Showing ${Math.min(
                    offset * limit + 1,
                    availableDataCount
                  )} to ${Math.min(
                    (offset + 1) * limit,
                    availableDataCount
                  )} of ${availableDataCount} entries`
                  : "Showing No Entries"}
              </p>
            </div>
            <div className="col-md-6 col-sm-6 pagebtnrespo">
              {" "}
              {generatePaginationFooter(
                availableDataCount,
                limit,
                offset,
                setOffset
              )}
            </div>
          </div>
          {/* {data.length == 0 ? null : (
            <div className="d-flex justify-content-center">
              <SubmitButtonTwo
                title={"Buy Mock Tests"}
                onclick={() => navigate(RoutesPath.dashboardstudent)}
                className="Buy-mocktest-btn mt-3"
              />
            </div>
          )} */}
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="rounded-5"
      >
        <div className="border m-5">
          <div
            className="d-flex justify-content-between mb-3 align-items-center px-3 py-2"
            id="contained-modal-title-vcenter"
            style={{ backgroundColor: "#EFF5FF" }}
          >
            <h2 className="Heading headingColor text-center fw-600">
              Instructions:
            </h2>
            <div className="medium-text fw-500 text-danger">
              Please read the instructions carefully before starting the test.
            </div>
          </div>

          <Modal.Body className="">
            <div className="container-fluid ps-4">
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 1. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Camera Visibility: Ensure your camera is on and you are
                    clearly visible from head to chest throughout the
                    examination.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 2. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Fair Play: Maintain academic integrity. Do not engage in any
                    form of cheating or malpractice.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 3. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    No Communication: Refrain from communicating with anyone
                    during the examination.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 4. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    No External Assistance: Do not seek help from any external
                    source, including textbooks, notes, or online resources.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 5. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Time Management: The examination duration is 90 minutes.
                    Allocate time wisely to answer all questions.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 6. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Question Format: The examination consists of 100 Multiple
                    Choice Questions (MCQs).
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 7. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Marking Scheme: Each correct answer carries 2 marks.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 8. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Submission Deadline: The examination will be automatically
                    submitted after 90 minutes. Ensure you submit your answers
                    before the deadline.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 9. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Result Implications: Any violation of the examination rules
                    may lead to the cancellation of your result.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 10. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    The merit list will be prepared based on the marks obtained
                    by the student and the time they took to complete the test.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 11. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Each incorrect answer will result in a deduction of 0.5
                    marks from your total score. Please be mindful of this when
                    answering the questions.
                  </em>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="text-center border-0 d-flex justify-content-center">
            <div>
              <SubmitButtonTwo
                title={"Start Test"}
                className="start-test-btn"
                onclick={handleStartTest}
              />
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default MyMockTest;
